import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-window',
  imports: [],
  templateUrl: './window.component.html',
  styleUrl: './window.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowComponent {
  public gradient = input<string>();
  @HostBinding('style.--gradient') public get gradientStyle() {
    return this.gradient();
  }

  public textColor = input<string>();
  @HostBinding('style.--textColor') public get textColorStyle() {
    return this.textColor();
  }
}
